module.exports = __webpack_public_path__ + "public/img/Mengelola Dokumen Untuk Staf Perkantoran Umum.cef3cdec.png";